// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/brand-variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/responsive-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Organization Switcher — reuses .topbar-avatar-btn, .topbar-dropdown, etc. from TopBar.css */
/* Only org-specific overrides are defined here. */

/* Spinner shown while switching */
.topbar-org-spinner {
  border: 2px solid var(--color-surface-dark);
  border-top-color: var(--color-primary);
  animation: org-spin 0.6s linear infinite;
}

@keyframes org-spin {
  to { transform: rotate(360deg); }
}

/* Error state avatar */
.topbar-avatar--error {
  background: #d44c4c;
}

.topbar-org-switcher--error {
  border-color: #d44c4c;
}

/* Scrollable org list */
.topbar-org-dropdown-list {
  max-height: 240px;
  overflow-y: auto;
}

/* Org item — extends .topbar-dropdown-item */
.topbar-org-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.topbar-org-item--active {
  background: var(--color-surface-light);
  border-left: 3px solid var(--color-primary);
}

.topbar-org-item-name {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topbar-org-item-role {
  font-size: 11px;
  color: var(--color-text-secondary);
  text-transform: capitalize;
  flex-shrink: 0;
  margin-left: 8px;
}

/* Section label in dropdown header */
.topbar-dropdown-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.topbar-org-name-static {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text-secondary, #94a3b8);
  padding: 0 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/OrganizationSwitcher.css"],"names":[],"mappings":"AAAA,8FAA8F;AAC9F,kDAAkD;;AAKlD,kCAAkC;AAClC;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;AACnB","sourcesContent":["/* Organization Switcher — reuses .topbar-avatar-btn, .topbar-dropdown, etc. from TopBar.css */\n/* Only org-specific overrides are defined here. */\n\n@import '../../../../shared/brand-variables.css';\n@import '../../../../shared/responsive-variables.css';\n\n/* Spinner shown while switching */\n.topbar-org-spinner {\n  border: 2px solid var(--color-surface-dark);\n  border-top-color: var(--color-primary);\n  animation: org-spin 0.6s linear infinite;\n}\n\n@keyframes org-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Error state avatar */\n.topbar-avatar--error {\n  background: #d44c4c;\n}\n\n.topbar-org-switcher--error {\n  border-color: #d44c4c;\n}\n\n/* Scrollable org list */\n.topbar-org-dropdown-list {\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n/* Org item — extends .topbar-dropdown-item */\n.topbar-org-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.topbar-org-item--active {\n  background: var(--color-surface-light);\n  border-left: 3px solid var(--color-primary);\n}\n\n.topbar-org-item-name {\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.topbar-org-item-role {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  text-transform: capitalize;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n/* Section label in dropdown header */\n.topbar-dropdown-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.topbar-org-name-static {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-text-secondary, #94a3b8);\n  padding: 0 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
